/// <amd-module name="Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionReducer" />
import produce from "immer";

import { CommandViewActionActions, CommandViewActionActionTypes } from "Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionActions";
import { CommandMap, ICommandState, ICommandTogglePayload } from "Tfs/ReduxCommon/Modules/CommandViewAction/CommandViewActionContracts";

export function commandViewActionReducer(state: ICommandState, action: CommandViewActionActions): ICommandState {
    state = state || getDefaultState();

    return produce(state, draft => {
        switch (action.type) {
            case CommandViewActionActionTypes.AddCommands:
                draft.commands = { ...(draft.commands || []), ...action.payload };
                break;
            case CommandViewActionActionTypes.AddViewActions:
                draft.viewActions = action.payload;
                break;
            case CommandViewActionActionTypes.ToggleCommandDisableState:
                setDisabled(action.payload, draft.commands);
                break;
            case CommandViewActionActionTypes.ToggleViewActionDisableState:
                setDisabled(action.payload, draft.viewActions);
                break;
        }
    });
}

function setDisabled(newState: ICommandTogglePayload[], commands: CommandMap): void {
    newState.forEach(item => {
        const { key } = item;

        if (commands[key]) {
            commands[key].disabled = !commands[key].disabled;
        }
    });
}

function getDefaultState(): ICommandState {
    return {
        commands: {},
        viewActions: {}
    };
}
